import { Interweave } from 'interweave';
import React, { FC } from 'react';
import ICtaIconBox from '../../../interfaces/elements/ctaIconBox';
import { A } from '../../base/typography';
import * as StyledCtaIconBox from './ctaIconBox.styles';

interface Props {
	box: ICtaIconBox;
}

const CtaIconBox: FC<Props> = ({ box }) => {
	return (
		<StyledCtaIconBox.Wrapper>
			<StyledCtaIconBox.ContentWrapper>
				<StyledCtaIconBox.BoxHeading>
					{box.Values.Title}
				</StyledCtaIconBox.BoxHeading>
				<StyledCtaIconBox.BoxText>
					<Interweave content={box.Values.Text} />
				</StyledCtaIconBox.BoxText>
				<A
					to={box.Values.Link ? box.Values.Link.Url : ''}
					target={box.Values.Link ? box.Values.Link.Target : ''}>
					{box.Values.Link ? box.Values.Link.Name : ''}
				</A>
			</StyledCtaIconBox.ContentWrapper>
			{box.Values.Icon !== '' && box.Values.Icon !== 'No Icon' ? (
				<StyledCtaIconBox.IconImage src={`/dist/icons/${box.Values.Icon}.svg`} alt={`${box.Values.Title}`} />
			) : (
				<StyledCtaIconBox.ImagePlaceholder />
			)}
		</StyledCtaIconBox.Wrapper>
	);
};

export default CtaIconBox;
